const initialGuestInfo = {
  guestName: "",
  guestEmail: "",
  confirmGuestEmail: "",
  guestPhoneNumber: "",
  confirmGuestPhoneNumber: "",
  guestNationality: "",
  specialRequest: "",
};
const initialErrors = {
  email: "",
  phone: "",
};

export { initialErrors, initialGuestInfo };
